function classicDrawerAccessibility() {
  document.querySelectorAll('[data-side-drawer]').forEach(drawer => {
    const open = drawer.classList.contains('sd-sidebar--visible');
    const value = String(!open);
    if (drawer.getAttribute('aria-hidden') !== value) drawer.setAttribute('aria-hidden', value);
  });
}
function classicMetalLabel(value) {
  const upper = value.toUpperCase();
  const twoTone = upper.includes('TWO') || (upper.includes('YELLOW') && upper.includes('WHITE'));
  if (twoTone && upper.startsWith('14K')) return '14K Two-tone gold';
  if (twoTone && upper.startsWith('18K')) return '18K Two-tone gold';
  return value.replace(/^14k/i, '14K').replace(/^18k/i, '18K');
}
function classicFilterLabels() {
  const form = document.getElementById('FiltersForm');
  if (!form || !form.querySelector('input[type="checkbox"]:not([data-cj-grouped])')) return;
  const groups = new Map();
  form.querySelectorAll('input[type="checkbox"]').forEach(input => {
    input.dataset.cjGrouped = 'true';
    const label = input.labels[0];
    const text = label?.textContent.trim() || input.title;
    input.setAttribute('aria-label', text);
    if (input.name !== 'filter.p.m.custom.metal') return;
    const name = classicMetalLabel(input.value);
    if (label) label.textContent = name;
    input.setAttribute('aria-label', name);
    if (!groups.has(name)) groups.set(name, []);
    groups.get(name).push(input);
  });
  groups.forEach(inputs => {
    const primary = inputs[0];
    primary.checked = inputs.some(input => input.checked);
    inputs.slice(1).forEach(input => {input.closest('li').hidden = true;});
    const syncAliases = () => {
      inputs.slice(1).forEach(input => {input.checked = primary.checked;});
    };
    primary.addEventListener('click', syncAliases, true);
    primary.addEventListener('change', syncAliases, true);
  });
}
function classicFloatingControls() {
  const chat = document.querySelector('shopify-chat');
  if (!chat) return;
  const sticky = document.getElementById('mobile-sticky-atc');
  const hide = (matchMedia('(max-width:767px)').matches && document.querySelector('.main-product-section')) || document.body.classList.contains('no-scroll') || (matchMedia('(max-width:767px)').matches && sticky && !sticky.classList.contains('atc-sticky-hidden'));
  chat.inert = Boolean(hide);
  if (hide) chat.setAttribute('aria-hidden', 'true');
  else chat.removeAttribute('aria-hidden');
}
function classicCurrentShape() {
  document.querySelectorAll('[data-cj-shape]').forEach(link => {
    const url = new URL(window.location.href);
    const active = url.searchParams.getAll('filter.p.m.custom.shape').includes(link.dataset.cjShape);
    if (active) link.setAttribute('aria-current', 'true');
    else link.removeAttribute('aria-current');
    url.searchParams.delete('filter.p.m.custom.shape');
    url.searchParams.delete('page');
    if (!active) url.searchParams.set('filter.p.m.custom.shape', link.dataset.cjShape);
    link.href = url.pathname + url.search;
  });
}
function classicControls() {
  classicDrawerAccessibility();
  classicCurrentShape();
  classicAppliedMetals();
  classicFilterLabels();
  classicFloatingControls();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', classicControls);
else classicControls();
new MutationObserver(classicControls).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['class']});
document.addEventListener('shopify:section:load', classicControls);
window.addEventListener('resize', classicFloatingControls);

function classicAppliedMetals() {
  const groups = new Map();
  document.querySelectorAll('.mg-applied-filter-remove:not([mg-applied-filter-cross-all])').forEach(link => {
    const label = link.textContent.trim();
    if (!/^(14|18)k/i.test(label)) return;
    const name = classicMetalLabel(label);
    if (groups.has(name)) {
      link.closest('li').hidden = true;
      return;
    }
    groups.set(name, link);
    const text = Array.from(link.childNodes).find(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (text && text.textContent !== name) text.textContent = name;
    const url = new URL(window.location.href);
    const keep = url.searchParams.getAll('filter.p.m.custom.metal').filter(value => classicMetalLabel(value) !== name);
    url.searchParams.delete('filter.p.m.custom.metal');
    keep.forEach(value => url.searchParams.append('filter.p.m.custom.metal', value));
    url.searchParams.delete('page');
    link.href = url.pathname + url.search;
  });
}
